import { uniqBy } from 'lodash';
import { createSelector } from 'reselect';

import { subjectsOrderSort } from 'store/courses/utils';
import { getSubjectConfigList } from 'store/subject-config/selectors';
import { getGradeFromProps } from 'utils/selectors/selectors';

import type { ReduxMainPageStore } from './typings';

const storeSelector = (storeState: ReduxMainPageStore) => storeState.mainPage;

export const getMainPageDataByGrade = createSelector([storeSelector, getGradeFromProps], (store, grade) => {
    return grade ? store?.pages[grade] : null;
});

export const getMainPageSubjects = createSelector(
    [getMainPageDataByGrade, getSubjectConfigList],
    (page, subjectConfig) => {
        // fixme EDUCATION-26866 возможно, что subjectConfig под каждый предмет здесь может не быть,
        // тк для неавторизованного мы запрашиваем все возможные курс темплейты
        if (!page?.page) {
            return [];
        }

        // fixme EDUCATION-26866
        // const coursesTemplates = page.page.coursesTemplates;
        const coursesTemplates = [
            {
                name: 'Русский язык',
                subject: 'russian',
            },
            {
                name: 'Математика',
                subject: 'mathematics',
            },
            {
                name: 'Окружающий мир',
                subject: 'nature',
            },
        ];

        return subjectsOrderSort(
            uniqBy(
                coursesTemplates.map((ct) => ({ subject: ct.subject, name: ct.name })),
                'subject'
            ),
            subjectConfig
        );
    }
);
